module.exports = __webpack_public_path__ + "static/img/alipay.40698e4a.png";